import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ $isEmpty: boolean }>`
  background-color: #f5f5f5;
  padding: 16px 24px;
  border-radius: 8px;
  margin-top: 16px;
  ${(props) =>
    props.$isEmpty
      ? css`
          .ant-select-selection {
            height: 40px;
            .ant-select-selection__rendered {
              height: 100%;
            }
          }
          .ant-select-selection--multiple {
            padding-bottom: 0;
          }
          .ant-select-arrow {
            top: 20px;
          }
        `
      : css`
          .ant-select-selection {
            min-height: 48px;
            max-height: 124px;
            overflow: auto;
            padding-bottom: 5px !important;
            .ant-select-selection__rendered {
              height: 100%;
              li {
                height: 100%;
                background-color: unset;
                margin-top: 4px;
                line-height: 0;
              }
            }
          }
          .ant-select-selection--multiple {
            padding-bottom: 0;
          }
          .ant-select-selection__choice__content {
            > div {
              margin-top: 1px;
              margin-bottom: 0;
              border: none;
              border-radius: 0;
              padding: 0;
              > svg {
                display: initial;
                cursor: pointer;
                margin: 0 2px 0 8px;
              }
            }
          }
          .ant-select-arrow {
            top: 50%;
          }
        `}
`

export const Subtitle = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 4px;
`

export const OptionWrapper = styled.div`
  margin-top: -7px;
  margin-bottom: -7px;
  svg {
    display: none;
  }
`
